export * from './dynamic-proxy-instance';
